import { createSelector } from "reselect";

const selectSlice = (state) => state.VendorInvoiceConfig || {};

export const selectCostTypes = createSelector(selectSlice, (s) => s.costTypes || []);
export const selectCategories = createSelector(selectSlice, (s) => s.categories || []);
export const selectSubCategories = createSelector(selectSlice, (s) => s.subCategories || []);
export const selectConfigLoading = createSelector(selectSlice, (s) => s.loading || false);
export const selectBudgets = createSelector(selectSlice, (s) => s.budgets || []);
export const selectBudgetsLoading = createSelector(selectSlice, (s) => s.budgetsLoading || false);

// { [costTypeId]: { RON: x, EUR: y } } — sum of all budgets per cost type
export const selectBudgetByCostType = createSelector(selectBudgets, (budgets) =>
  budgets.reduce((acc, b) => {
    const ctId = b.category_detail?.cost_type_detail?.id;
    if (!ctId) return acc;
    if (!acc[ctId]) acc[ctId] = {};
    const currency = b.currency || "RON";
    acc[ctId][currency] = (acc[ctId][currency] || 0) + parseFloat(b.amount || 0);
    return acc;
  }, {})
);

// Total budget across all entries: { RON: x, EUR: y }
export const selectTotalBudget = createSelector(selectBudgets, (budgets) =>
  budgets.reduce((acc, b) => {
    const currency = b.currency || "RON";
    acc[currency] = (acc[currency] || 0) + parseFloat(b.amount || 0);
    return acc;
  }, {})
);
